import "./BreadcrumbStyles.scss";
import $ from "jquery";
const breadcrumb = () => {
    $(() => {
        const $activePage = $(".breadcrumb ol li").last();
        const $a = $activePage.prevAll().eq(1).find("a");
        const previousLink = $a.attr("href");
        const previousText = $a.text();
        $(".previous-button a").attr("aria-label", previousText).attr("href", previousLink);
    });
};
export { breadcrumb };
